var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_outer",style:({ backgroundImage: 'url(' + _vm.userBgLogo + ')' })},[_c('div',{staticClass:"login_content"},[_c('router-view')],1),_c('Footer',{staticClass:"login_footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }